/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './lockConvo.defs'
export { main as default } from './lockConvo.defs'
